import TranslateUtils from 'src/js/common/utils/translate_utils';
import {getEnumValue} from 'src/js/containers/enum/enum_selectors';

import {RenderingServices, TranslateEnumParams} from '../types';

export function baseTranslatedEnumValueParams(params: TranslateEnumParams, services: RenderingServices = {}) {
  const {intl, store} = services;
  const {enumName, enumValueName} = params;
  const state = store && store.getState();

  const enumValue = getEnumValue(state, enumName, enumValueName);

  const plainTranslatedValue = (enumValue && intl && TranslateUtils.translate(enumValue, intl)) || enumValueName;
  return {plainTranslatedValue};
}
